module.exports = __webpack_public_path__ + "static/media/LancamentosFinanceiros8.e98b91c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancLancamentosFinanceiros/LancamentosFinanceiros8.png
// module id = 2157
// module chunks = 0